<template>
  <nav class="navbar navbar-expand-lg navbar-dark avivo-navbar">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link
        class="nav-link"
        to="/"
      >
        <span
          class="navbar-brand"
          href="#"
        >
          <img
            src="../../assets/images/archiviovivo_logo.png"
            height="30"
            alt=""
            loading="lazy"
          >
        </span>
      </router-link>
      <div
        class="collapse navbar-collapse"
        id="navbarTogglerDemo01"
      >
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link
              class="nav-link header-menu"
              to="/"
            >Home</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link header-menu"
              to="/patrimonio-audiovisivo"
            >Patrimonio Audiovisivo</router-link>
          </li>
          <li class="nav-item ">
            <router-link
              class="nav-link header-menu"
              to="/caterina-bueno"
            >Caterina Bueno</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link header-menu"
              to="/clarin-it"
            >Clarin-IT</router-link>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://twitter.com/archiviovi"
            >
              <i class="bi bi-twitter"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://www.facebook.com/archivioVi.Vo/"
            >
              <i class="bi bi-facebook"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<style>
.avivo-navbar {
  background-color: #242b83;
}

.header-menu.active{
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-bottom-color: white;
}
</style>